import React, { useState } from 'react';
import { Button, colors, Select } from '@insurancemenu/imenu-components-lib';
import { NavigationClose } from '@insurancemenu/imenu-components-lib/dist/icons';
import { subscriberStockClasses } from 'global/utils/election/subscriberClassHelper';
import { createStyles } from './styles';
import EeClassTypeTitle from '../EeClassTypeTitle';

const stockOptions = subscriberStockClasses.map((stockClass) => ({
  value: stockClass,
  label: stockClass,
}));

const EeClassesGuidelines = (): JSX.Element => {
  const classes = createStyles();
  const [sampleClassName, setSampleClassName] = useState('Retirees');
  return (
    <div className={classes.guidelinesContent}>
      <p>
        Use Classes and Locations to organize employees and manage product line availability. You can choose from our
        Stock classes or you can create your own Custom or Location based classes.
      </p>
      <p>
        Remember to remove any Stock or Custom/Location class not being used. Once you&apos;ve created your classes, you
        will be prompted to verify what product lines are available by class.
      </p>
      <p>
        Finally, once you activate classes - you will have to assign each employee in the elections page to a class or
        location before you close open enrollment.
      </p>
      <EeClassTypeTitle type="STOCK" styles={classes.typeTitle} />
      <div className={classes.sampleClass}>
        <Select
          label="Class 1"
          name="guideline-stock-sample"
          options={stockOptions}
          value={sampleClassName}
          width="23rem"
          onChange={(event): void => {
            setSampleClassName(event.target.value);
          }}
          className={classes.sampleSelect}
        />
        <Button
          leftIconProp={<NavigationClose />}
          type="text"
          color="custom"
          customColor={colors.red[600]}
          className={classes.sampleRemoveBtn}
          uppercase
        >
          Remove
        </Button>
      </div>
    </div>
  );
};

export default EeClassesGuidelines;
